interface EmailPreviewProps {
  html: string;
  viewMode: "desktop" | "mobile";
}

export function EmailPreview({ html, viewMode }: EmailPreviewProps) {
  const width = viewMode === "desktop" ? 600 : 375;

  return (
    <div className="flex justify-center overflow-x-auto">
      <iframe
        srcDoc={html || "<p style='color:#999;text-align:center;padding:40px;font-family:sans-serif;'>Preview will appear here</p>"}
        title="Email preview"
        className="rounded-lg border border-zinc-200 bg-white dark:border-zinc-700"
        style={{ width, maxWidth: "100%", height: 560 }}
      />
    </div>
  );
}
